// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3eJYx","signatureButtonsRight":"ModalSign_signatureButtonsRight__1Q76F"};